// Client-side constants for the admin-billing contract
// (src/contracts/admin-billing-api.json, shield-control#166).
// Side-effect free on purpose: the drift test imports this module, so it must
// not pull in the Supabase client (which requires VITE_* env at module load).
export const BILLING_FN_PATH = "/functions/v1/admin-billing";
export const BILLING_ACTIONS = ["get_overview", "change_plan", "cancel", "start_subscription", "link_customer"] as const;
export type BillingAction = (typeof BILLING_ACTIONS)[number];
